import { Injectable } from '@angular/core';
import {SyncService} from '../OffService/sync.service';
import {ApiRequestService, HttpRequestType} from '../OffService/api-request.service';
import {RequestHandler} from '../OffService/request-handler';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UsuariosApiService {

    public usuariosGET: RequestHandler = new RequestHandler();
    public usuariosGenericGET: RequestHandler = new RequestHandler();
    public usuariosDELETE: RequestHandler = new RequestHandler();
    public usuariosPUT: RequestHandler = new RequestHandler();
    public usuariosPOST: RequestHandler = new RequestHandler();

    public profesionalesGET: RequestHandler = new RequestHandler();

    constructor(private syncService: SyncService,
        private api: ApiRequestService) {

        this.defineUsuarios();
        this.defineProfesionales();
    }

    public defineUsuarios() {
        this.usuariosGET.fetch(HttpRequestType.GET, 'user/getusers');
        this.usuariosGenericGET.fetch(HttpRequestType.GET, 'generic/usuarios');

        if (environment.features.applicationType === 'cropgest') {
            this.usuariosPOST.fetch(HttpRequestType.POST, 'user/register');
        } else {
            this.usuariosPOST.fetch(HttpRequestType.POST, 'generic/usuarios');
        }

        if (environment.features.canRegister || environment.features.applicationType === 'cropgest') {
            
            this.usuariosPUT.fetch(HttpRequestType.PUT, 'user/put');
            this.usuariosDELETE.fetch(HttpRequestType.DELETE, 'user/delete');
        } else {
            this.usuariosDELETE.fetch(HttpRequestType.DELETE, 'generic/usuarios');
            this.usuariosPUT.fetch(HttpRequestType.PUT, 'generic/usuarios');
        }

        this.api.registerRequest(this.usuariosGET);
        this.api.registerRequest(this.usuariosGenericGET);
        this.api.registerRequest(this.usuariosPOST);
        this.api.registerRequest(this.usuariosPUT);
        this.api.registerRequest(this.usuariosDELETE);

        this.syncService.register(this.syncService.baseSyncPolicy(this.usuariosGET));
        this.syncService.register(this.syncService.baseSyncPolicy(this.usuariosGenericGET));
        this.syncService.register(this.syncService.baseSyncPolicy(this.usuariosPOST));
        this.syncService.register(this.syncService.baseSyncPolicy(this.usuariosPUT));
        this.syncService.register(this.syncService.baseSyncPolicy(this.usuariosDELETE));
    }


    public defineProfesionales() {
        this.profesionalesGET.fetch(HttpRequestType.GET, 'user/getprofesionales');
        this.api.registerRequest(this.profesionalesGET);
        this.syncService.register(this.syncService.baseSyncPolicy(this.profesionalesGET));
    }
}
